module.exports = __webpack_public_path__ + "img/icon-like-hand.82c8ec55.svg";